import PaperCheckInstructionsModal from "./paymentDetailsCard/paperCheckInstructionsModal";
import PaperCheckConfirmationModal from "./paymentDetailsCard/paperCheckConfirmationModal";
import React from "react";
import {PaymentDetails} from "./paymentDetailsCard/PaymentDetailsContainer";


const PaperCheck = ({strings, loading, onSubmit}) => {
    const {
        paperCheckInstructionsVisibility,
        paperCheckConfirmationVisibility,
    } = PaymentDetails.useContainer();

    return (
        <>
            { paperCheckInstructionsVisibility &&
            <PaperCheckInstructionsModal strings={strings} />
            }
            { paperCheckConfirmationVisibility &&
            <PaperCheckConfirmationModal strings={strings} onConfirm={onSubmit} loading={loading} />
            }
        </>
    );
}

export default PaperCheck;